import * as _ from 'lodash';
import { QuickQuoteService } from './quick-quote.service';
import { QUICK_QUOTE_CONSTANTS } from '../quick-quote.constants';
import * as i0 from "@angular/core";
import * as i1 from "./quick-quote.service";
export class GrayoutService {
    constructor(quickQuoteService) {
        this.quickQuoteService = quickQuoteService;
        this.constants = QUICK_QUOTE_CONSTANTS;
    }
    /**
     * Checks the filters selected to enable or disable the others filters
     */
    checkGrayout() {
        let finalEnabledList;
        const tempSelectedFilters = this.quickQuoteService.getTempFiltersSelected();
        const specialFilter = this.quickQuoteService.getSpecialFilter();
        if (specialFilter) {
            finalEnabledList = specialFilter.enabled || [];
        }
        if (_.flattenDeep(tempSelectedFilters).length) {
            finalEnabledList = finalEnabledList || [];
            tempSelectedFilters.forEach((filterGroup, index) => {
                // (has arrays as subgroups (ie: more filters)
                if (filterGroup.some(Array.isArray)) {
                    // more filters
                    filterGroup.forEach((moreFilterGroup) => {
                        finalEnabledList = this.getEnabledList(finalEnabledList, moreFilterGroup, true);
                    });
                }
                else {
                    // date, destination and city filters
                    finalEnabledList = this.getEnabledList(finalEnabledList, filterGroup, false);
                }
            });
        }
        this.disableFilters(finalEnabledList);
    }
    /**
     * Retrives the enabled filter id list based on the filter group provided
     * @param finalEnabledList final enabled filters ids list
     * @param filterGroup filters group
     * @param isMoreFilters flag to know if the filter group is a more filters group
     * @returns enabled filters ids
     */
    getEnabledList(finalEnabledList, filterGroup, isMoreFilters) {
        let mergedList = [];
        const filtersData = this.quickQuoteService.getFiltersData();
        if (isMoreFilters) {
            filterGroup.forEach((filter) => {
                mergedList = [
                    ...mergedList,
                    ...filtersData[filter.id].enabled,
                    ...this.getFiltersByType(filter.groupType)
                ];
            });
        }
        else {
            filterGroup.forEach((filter) => {
                mergedList = [
                    ...mergedList,
                    ...filtersData[filter.id].enabled,
                    ...this.getFiltersByType(filter.type)
                ];
            });
        }
        if (!finalEnabledList.length) {
            finalEnabledList = mergedList;
        }
        else if (mergedList.length > 0) {
            finalEnabledList = finalEnabledList.filter(filterId => mergedList.includes(filterId));
        }
        return finalEnabledList;
    }
    /**
     * Returns the filter ids with the filter type provided
     * @param filterType Filter type
     * @returns Filters ids list
     */
    getFiltersByType(filterType) {
        const relatedFilters = [];
        const filtersData = this.quickQuoteService.getFiltersData();
        _.forIn(filtersData, (rawFilter) => {
            if (rawFilter.type === filterType) {
                relatedFilters.push(rawFilter.id);
            }
        });
        return relatedFilters;
    }
    /**
     * Enables or disables filters from the model based on the filter ids list provided
     * @param filtersIds Filters id list
     */
    disableFilters(filtersIds) {
        const filtersModel = this.quickQuoteService.getModel();
        filtersModel.forEach((filter) => {
            switch (filter.type) {
                case this.constants.filters['date'].id:
                    filter.data.forEach((gridConfig) => {
                        gridConfig.contentData.forEach((gridContent) => {
                            gridContent.isDisabled = !!filtersIds && !filtersIds.includes(gridContent.id);
                        });
                    });
                    break;
                case this.constants.filters['destination'].id:
                case this.constants.filters['privateIsland'].id:
                case this.constants.filters['city'].id:
                    filter.data.forEach((imagePicker) => {
                        imagePicker.disabled = !!filtersIds && !filtersIds.includes(imagePicker.id);
                    });
                    break;
                case this.constants.filters['more-filters'].id:
                    filter.data.forEach((optionsGroup) => {
                        optionsGroup.options.forEach((optionItem) => {
                            optionItem.disabled = !!filtersIds && !filtersIds.includes(optionItem.id);
                        });
                    });
                    break;
            }
        });
    }
}
GrayoutService.ngInjectableDef = i0.ɵɵdefineInjectable({ factory: function GrayoutService_Factory() { return new GrayoutService(i0.ɵɵinject(i1.QuickQuoteService)); }, token: GrayoutService, providedIn: "root" });
